<template>
  <div class="circle-content circle-content--inner-circle circle-content--default circle-base__content--shadow">
    <RoundCheckbox
      :list="step.list"
      :activeList="getActiveList"
      :value="getFormData.flavour"
      :multiple="true"
      @input="setValue($event)"
    />
    <lazy-img :src="step.image" class="circle-content__img" />
    <div class="circle-content__title fade-in" v-html="$t(step.title)"></div>
    <div class="circle-content__description fade-in" v-html="$t(step.description)"></div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default new Circle(Steps.FLAVOUR).comp;
</script>
